import React from 'react'; 
import img_twitter from './../../../Icone/Twitter social icons - circle - blue.png'
import img_fb from './../../../Icone/f_logo_RGB-Blue_100.png'
require('./footer.css')
/*
    this class is the footer a part we can find at the bottom of a page
    there is a link to our social network
    our information like cell phone or email 
    and link to home page, services, contact and our general condition of use
*/
interface FooterProps {

}

interface FooterState {
}

export default class Header extends React.Component<FooterProps, FooterState> {

	constructor(props: FooterProps) {
		super(props)
		this.state = {
		}

	}

	render() {
		return (
				<footer className="ftco-footer ftco-bg-dark ftco-section">
                    <div className="container">
                        <div className="row mb-5">
                            <div className="col-md">
                                <div id="identity-cfm" className="ftco-footer-widget mb-4">
                                    <h2 className="ftco-heading-2">
                                        Privasee
                                    </h2>
                                    <p>
                                        Simplifier les CGU, dénoncer celles qui sont abusives
                                    </p>
                                </div>
                            </div>
                            <div className="col-md">
                                <div id="fast-link" className="ftco-footer-widget mb-4 ml-5">
                                    <h2 className="ftco-heading-2">
                                        Liens rapides
                                    </h2>
                                    <ul className="list-unstyled">
                                        <li>
                                            <a id="nav-foot" className="py-2 d-block" href="/accueil">Accueil</a>
                                        </li>
                                        <li>
                                            <a id="nav-foot" className="py-2 d-block" href="/service">Nos services</a>
                                        </li>
                                        <li>
                                            <a id="nav-foot" className="py-2 d-block" href="/contact">Contact</a>
                                        </li>
                                        <li>
                                            <a id="nav-foot" className="py-2 d-block" href="/cgu">Conditions Générales d'utilisation</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-md">
                                <div id="contact-us" className="ftco-footer-widget mb-4">
                                    <h2 className="ftco-heading-2">
                                        Nous contacter
                                    </h2>
                                    <ul className="list-unstyled">
                                        <li>
                                            <span id="nav-foot" className="py-2 d-block" style={{color: "white", opacity: "0.7"}}>85, Rue du Jardin Public 33000 Bordeaux</span>
                                        </li>
                                        <li>
                                            <span id="nav-foot" className="py-2 d-block" style={{color: "white", opacity: "0.7"}}>+33 8 64 82 73 91</span>
                                        </li>
                                        <li>
                                            <span id="nav-foot" className="py-2 d-block" style={{color: "white", opacity: "0.7"}}>info@privasee.com</span>
                                        </li>
                                        <li>
                                            <span id="nav-foot" className="py-2 d-block" style={{color: "white", opacity: "0.7"}}>privasee@privasee.com</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            
                            <div className="col-md">
                                <div className="ftco-footer-widget mb-4">
                                    <ul className="ftco-footer-social list-unstyled float-md-left float-lft">
                                        <li className="ftco-animate fadeInUp ftco-animated">
                                            <a href="https://twitter.com/_PrivaSee" target="__blank">
                                                <span className="icon-twitter"> <img id="twitter_img" alt="twitter_img" src={img_twitter}></img></span>
                                            </a>
                                        </li>
                                        <li className="ftco-animate fadeInUp ftco-animated">
                                            <a href="https://www.facebook.com/privaSeeGroup" target="__blank">
                                                <span className="icon-facebook"><img id="facebook_img" alt="facebook_img" src={img_fb}></img></span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
		);
	}

}